import EmptyAttachments from "./EmptyAttachments";

export default EmptyAttachments;
